var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order_document_page"},[_c('div',{staticClass:"wangEditor",domProps:{"innerHTML":_vm._s(_vm.orderDocument)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }